import Vue from 'vue'
import { v4 as uuidv4 } from 'uuid'
import { ApiClient } from '@ahaslides-product/plugins-api'
import configs from '@/config'

let resource = null

const actions = {
  getLatestLeaderboard: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presentation/v2/latest-leaderboard/{presentationId}`,
  },

  createSlideLeaderboardInvidiual: {
    method: 'POST',
    url: `${configs.api.createLeaderboard}`,
  },
  addManualPoint: {
    method: 'POST',
    url: `${configs.baseUrl}/api/score/`,
  },
  createBonusResult: {
    method: 'POST',
    url: `${configs.liveProxyUrl}/api/live/answers/results`,
  },
  createLeaderboardSlideSnapshot: {
    method: 'POST',
    url: `${configs.kvSyncApiUrl}/api/aha-sync/answers/leaderboards/slide/snapshot`,
  },
  getLeaderboardSlideTopN: {
    method: 'GET',
    url: `${configs.kvSyncApiUrl}/api/aha-sync/answers/leaderboards/slide/topn`,
  },
  getLeaderboardSlideStreaks: {
    method: 'GET',
    url: `${configs.kvSyncApiUrl}/api/aha-sync/answers/leaderboards/slide/streaks`,
  },
  createLeaderboardSlideSnapshotFromScoreboard: {
    method: 'POST',
    url: `${configs.kvSyncApiUrl}/api/aha-sync/answers/leaderboard/slide/snapshot`,
  },
  getLeaderboardSlideTopNFromScoreboard: {
    method: 'GET',
    url: `${configs.kvSyncApiUrl}/api/aha-sync/answers/leaderboard/slide/topn`,
  },
  getLeaderboardSlideStreaksFromScoreboard: {
    method: 'GET',
    url: `${configs.kvSyncApiUrl}/api/aha-sync/answers/leaderboard/slide/streaks`,
  },
  getSelfPacedLeaderboardTopN: {
    method: 'GET',
    url: `${configs.kvSyncApiUrl}/api/aha-sync/answers/self-paced/leaderboard/topn`,
  },
  getSelfPacedLeaderboardSlideTopN: {
    method: 'GET',
    url: `${configs.kvSyncApiUrl}/api/aha-sync/answers/self-paced/leaderboard/slide/topn`,
  },
  getSelfPacedLeaderboardSlideStreaks: {
    method: 'GET',
    url: `${configs.kvSyncApiUrl}/api/aha-sync/answers/self-paced/leaderboard/slide/streaks`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const generateRandomEmoji = () => {
  return String.fromCodePoint(0x1F601 + Math.floor(Math.random() * 50))
}

const generateFakeAudiences = (count, topPoint) => {
  const audiences = []
  for (let i = count; i >= 0; i--) {
    audiences.push({
      audience: `bd2982e13e344088ad050167f49c${i}`,
      audienceName: `Audience ${i}`,
      audienceEmoji: generateRandomEmoji(),
      audienceTeam: 0,
      totalPoint: topPoint - (count - i) * topPoint * 0.02,
      index: count - i + 1,
    })
  }
  return audiences
}
export const fakeLeaderboardResp = {
  audiences: generateFakeAudiences(10, 1000),
  teams: null,
  cursor: '',
  hasNext: false,
  topAudienceStr: 'Ma',
}

const addManualPoint = async ({
  presentationId, audienceId, teamId, point, slideId,
}) => {
  const res = await resource.addManualPoint({
    presentationId, audienceId, teamId, point, slideId,
  })
  return res.body
}

const getLatestLeaderboard = async (payload, params = {}) => {
  const res = await resource.getLatestLeaderboard({
    presentationId: payload.presentationId,
    ...params,
  })
  if (res.body && res.body.audiences) {
    res.body.audiences = res.body.audiences.map((item) => {
      item.oP = item.oP || 0
      return {
        audienceName: item.aN,
        audienceEmoji: item.aE,
        audience: item.audience,
        audienceTeam: item.aT,
        totalPoint: item.tP,
        index: item.i,
        oldPoint: item.oP,
        newPoint: item.tP - item.oP,
        correctRate: item.cR,
        correctAnswersCount: item.cAc,
        streak: item.s,
        longestStreak: item.ls,
      }
    })
  }
  if (res.body && res.body.teams) {
    res.body.teams.forEach((team) => {
      team.oldPoint = team.oldPoint || 0
      team.newPoint = team.totalPoint - team.oldPoint
    })
  }
  if (res.body.countWinner === 1) {
    res.body.topAudienceStr = ''
  }
  return res.body
}

const getAggregation = (subject, teamScoringRule) => {
  if (subject === 'team') {
    if (teamScoringRule === 'average') {
      return 'average_score'
    }
    if (teamScoringRule === 'fastest') {
      return 'first_score'
    }
  }
  return 'total_score'
}

const SCORING_BY_AGGREGATION = { total_score: 'total', average_score: 'average', first_score: 'fastest' }

const getScoring = (subject, teamScoringRule) => SCORING_BY_AGGREGATION[getAggregation(subject, teamScoringRule)]

const toLeaderboardBody = (res, subject) => {
  const items = res?.items || []
  const winners = items.filter((item) => item.rank === 1)
  const winnerStr = winners.map((item) => item.name).join(', ')
  if (subject === 'team') {
    return {
      teams: items.map((item) => ({
        id: item.id,
        name: item.name,
        totalPoint: item.score,
        index: item.rank,
        oldPoint: item.oldScore || 0,
        newPoint: item.score - (item.oldScore || 0),
        members: (item.members || []).map((m) => ({
          audienceName: m.name,
          audienceEmoji: m.emoji,
        })),
      })),
      countTeamWinner: winners.length,
      topTeamStr: winners.length === 1 ? '' : winnerStr,
    }
  }
  return {
    audiences: items.map((item) => ({
      audience: item.id,
      audienceName: item.name,
      audienceEmoji: item.emoji,
      totalPoint: item.score,
      index: item.rank,
      oldPoint: item.oldScore || 0,
      newPoint: item.score - (item.oldScore || 0),
      audienceTeam: item.teamId,
    })),
    countWinner: winners.length,
    topAudienceStr: winners.length === 1 ? '' : winnerStr,
  }
}

const getLeaderboardTopN = async ({
  presentationId,
  presentationVersion,
  subject,
  teamScoringRule,
  n,
  leaderboardFromScoreboard,
}) => {
  const aggregation = getAggregation(subject, teamScoringRule)
  const client = new ApiClient(configs.kvSyncApiUrl)
  if (leaderboardFromScoreboard) {
    const params = new URLSearchParams({
      presentationId, presentationVersion, subject, scoring: getScoring(subject, teamScoringRule), n,
    })
    const res = await client.fetchUrl(`${configs.kvSyncApiUrl}/api/aha-sync/answers/leaderboard/topn?${params}`)
    return toLeaderboardBody(res, subject)
  }
  const res = await client.getLeaderboardTopN({
    presentationId,
    presentationVersion,
    subject,
    n,
    aggregation,
  })
  return toLeaderboardBody(res, subject)
}

const getLeaderboardSlideTopN = async ({
  presentationId,
  presentationVersion,
  subject,
  teamScoringRule,
  slideIds,
  n,
  leaderboardFromScoreboard,
}) => {
  if (leaderboardFromScoreboard) {
    const res = await resource.getLeaderboardSlideTopNFromScoreboard({
      presentationId,
      presentationVersion,
      subject,
      scoring: getScoring(subject, teamScoringRule),
      sumSlideIds: JSON.stringify(slideIds),
      n,
    })
    return toLeaderboardBody(res.body, subject)
  }
  const res = await resource.getLeaderboardSlideTopN({
    presentationId,
    presentationVersion,
    subject,
    aggregation: getAggregation(subject, teamScoringRule),
    slideIds: JSON.stringify(slideIds),
    n,
  })
  return toLeaderboardBody(res.body, subject)
}

const createLeaderboardSlideSnapshot = async ({
  presentationId,
  presentationVersion,
  slideId,
  slideIds,
  sumSlideIds,
  lastSlideId,
  subject,
  teamScoringRule,
  leaderboardFromScoreboard,
}) => {
  if (leaderboardFromScoreboard) {
    const res = await resource.createLeaderboardSlideSnapshotFromScoreboard({}, {
      presentationId,
      presentationVersion,
      snapshotSlideId: slideId,
      atSlideId: sumSlideIds ? undefined : slideId,
      sumSlideIds,
      compareAtSlideId: lastSlideId,
      subject,
      scoring: getScoring(subject, teamScoringRule),
    })
    return toLeaderboardBody(res.body, subject)
  }
  const aggregation = getAggregation(subject, teamScoringRule)
  const res = await resource.createLeaderboardSlideSnapshot({}, {
    presentationId,
    presentationVersion,
    slideId,
    slideIds,
    lastSlideId,
    subject,
    aggregation,
  })
  return toLeaderboardBody(res.body, subject)
}

const getSelfPacedLeaderboardTopN = async ({
  presentationId,
  presentationVersion,
  subject,
  teamScoringRule,
  attemptPolicy,
  n,
}) => {
  const res = await resource.getSelfPacedLeaderboardTopN({
    presentationId,
    presentationVersion,
    subject,
    scoring: getScoring(subject, teamScoringRule),
    attemptPolicy,
    n,
  })
  return toLeaderboardBody(res.body, subject)
}

const getSelfPacedLeaderboardSlideTopN = async ({
  presentationId,
  presentationVersion,
  leaderboardSlideId,
  sumSlideIds,
  subject,
  teamScoringRule,
  attemptPolicy,
  n,
}) => {
  const res = await resource.getSelfPacedLeaderboardSlideTopN({
    presentationId,
    presentationVersion,
    atSlideId: sumSlideIds ? undefined : leaderboardSlideId,
    sumSlideIds: sumSlideIds ? JSON.stringify(sumSlideIds) : undefined,
    subject,
    scoring: getScoring(subject, teamScoringRule),
    attemptPolicy,
    n,
  })
  return toLeaderboardBody(res.body, subject)
}

const createSlideLeaderboardIndividual = async (payload) => {
  const res = await resource.createSlideLeaderboardInvidiual(payload)
  return res.body
}

const toStreakLeader = (item, field) => item && {
  audience: item.id,
  audienceName: item.name,
  audienceEmoji: item.emoji,
  [field]: item.score,
}

const toStreakLeaders = (body) => ({
  streakLeader: toStreakLeader(body?.currentStreak?.items?.[0], 'streak'),
  longestStreakLeader: toStreakLeader(body?.longestStreak?.items?.[0], 'longestStreak'),
})

const getLeaderboardSlideStreaks = async ({
  presentationId,
  presentationVersion,
  slideIds,
  leaderboardSlideId,
  leaderboardFromScoreboard,
}) => {
  const res = leaderboardFromScoreboard
    ? await resource.getLeaderboardSlideStreaksFromScoreboard({
      presentationId, presentationVersion, atSlideId: leaderboardSlideId,
    })
    : await resource.getLeaderboardSlideStreaks({
      presentationId, presentationVersion, slideIds: JSON.stringify(slideIds),
    })
  return toStreakLeaders(res.body)
}

const getSelfPacedLeaderboardSlideStreaks = async ({
  presentationId,
  presentationVersion,
  leaderboardSlideId,
  attemptPolicy,
}) => {
  const res = await resource.getSelfPacedLeaderboardSlideStreaks({
    presentationId,
    presentationVersion,
    atSlideId: leaderboardSlideId,
    attemptPolicy,
  })
  return toStreakLeaders(res.body)
}

const createBonusResult = async ({
  presentationId,
  presentationVersion,
  audienceId,
  teamId,
  slideId,
  point,
}) => {
  const result = {
    timestamp: Date.now(),
    presentationId: Number(presentationId),
    presentationVersion: Number(presentationVersion),
    resultId: uuidv4(),
    points: point,
    scoreChannel: 'bonus',
    retention: 'ALL',
  }
  if (slideId) result.slideId = Number(slideId)
  if (teamId) result.teamId = String(teamId)
  if (audienceId) result.participantId = audienceId
  const res = await resource.createBonusResult({}, { results: [result] })
  return res.body
}

export default {
  initResource,
  getLatestLeaderboard,
  getLeaderboardTopN,
  getLeaderboardSlideTopN,
  createLeaderboardSlideSnapshot,
  getLeaderboardSlideStreaks,
  getSelfPacedLeaderboardTopN,
  getSelfPacedLeaderboardSlideTopN,
  getSelfPacedLeaderboardSlideStreaks,
  createSlideLeaderboardIndividual,
  addManualPoint,
  createBonusResult,
}
